import { createLogic } from "redux-logic"

import { LOAD_CONFIG, LOADED_CONFIG } from "./action_types"

import { dispatchError } from "utilities/dispatch-error"
import { fetchJson } from "utilities/fetch-json"

const loadConfig = createLogic({
    type: LOAD_CONFIG,

    async process(_, dispatch, done) {
        try {
            dispatch({
                type: LOADED_CONFIG,
                config: await fetchJson("/config/auth0.json"),
            })
        } catch (err) {
            dispatchError(dispatch, err)
        }

        done()
    },
})

export default [loadConfig]
